(function () {
    angular
        .module('sodCommon')
        .filter('isMultipleEnumType', isMultipleEnumType);

    function isMultipleEnumType(lodash) {
        return function(type) {
                if (!lodash.isString(type)) {
                return false;
            }

            return type.indexOf('multiple_enum_type') >= 0;
        }
    }
})();